import React from 'react'
import { PGATLD } from '../../helpers/constants'
import { IntercomAPI } from '@pga/react-intercom'
import styled from 'styled-components'

const StyledLink = styled.span`
  cursor: pointer;
  color: #007bff;
  &:hover {
    text-decoration: underline;
    color: #0056b3;
  }
`

export const IntercomLink = () => <StyledLink onClick={() => IntercomAPI('show')} data-testid='intercom-link'>click here</StyledLink>

export default () => (
  <p>Please try reloading the page, if the problem persists please <IntercomLink /> to submit a support request.</p>
)

export const PaymentFailure = () => (
  <div>
    <p>There was an error processing your payment, if the problem persists please <IntercomLink /> to submit a support request.</p>
    <p><a href={`https://${PGATLD}`} target='_blank' rel='noopener noreferrer'>Return to PGA.org</a></p>
  </div>
)

export const NoInvoicesFound = () => (
  <div>
    <p>No invoices found, if you believe this is an error please <IntercomLink /> to submit a support request.</p>
    <p><a href={`https://${PGATLD}`} target='_blank' rel='noopener noreferrer'>Return to PGA.org</a></p>
  </div>
)
